import { normalizeJotformEmbedsInContainer } from './jotformEmbed';

const EMBED_PAGE = `${process.env.PUBLIC_URL || ''}/jotform-embed.html`;

function createJotformWrapperIframe(formId) {
  const iframe = document.createElement('iframe');
  iframe.className = 'jotform-embed-frame';
  iframe.src = `${EMBED_PAGE}?id=${formId}`;
  iframe.title = 'Embedded form';
  iframe.setAttribute('allow', 'geolocation; microphone; camera; fullscreen; payment');
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('scrolling', 'yes');
  iframe.style.cssText =
    'width:100%;min-width:100%;max-width:100%;height:820px;border:none;display:block;background:#fff;';
  return iframe;
}

/**
 * Replace .jotform-embed placeholders with an isolated wrapper iframe (same pattern as Investors page).
 */
export function mountJotformEmbeds(container) {
  if (!container) return;

  normalizeJotformEmbedsInContainer(container);

  container.querySelectorAll('.jotform-embed').forEach((el) => {
    if (el.dataset.loaded === 'true') return;

    const formId = el.dataset.formId;
    if (!formId || !/^\d+$/.test(formId)) return;

    el.innerHTML = '';
    el.appendChild(createJotformWrapperIframe(formId));
    el.dataset.loaded = 'true';
  });
}

export default mountJotformEmbeds;
